import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Motor Subscription Ads
 */
export class SubscriptionCommitmentOptionsValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {Boolean} deps.hasNoCommitmentOption
   * @param {Array<Number>} deps.commitmentMonths
   */

  getCommitmentMonths = () => this._commitmentMonths
  getHasNoCommitmentOption = () => this._hasNoCommitmentOption
}
